// extracted by mini-css-extract-plugin
module.exports = {"sticky_container":"styles_sticky_container__q5_0X","page_header":"styles_page_header__I_MWW"};